<template>
  <footer class="footer">
    <div class="container-fluid">
      <nav>
        <ul class="footer-menu">
          <li>
            <router-link :to="{path:'/me'}">Dashboard</router-link>
          </li>
        </ul>
      </nav>
      <div class="copyright text-center">
        inthefish.com v{{version}} &copy; Arketec Limited {{year}}
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  setup(props, context) {
    const d = new Date()
    const year = d.getFullYear()
    const version = process.env.PACKAGE_VERSION
    
    return {
      version,
      year
    }
  }
}

</script>
<style>

</style>
